import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom';

import { SettingsContext } from '../contexts/index.jsx';
import { Alert, Button } from "./ui"

const PartExchangeButton = ({ listing }) => {
  const { isShopify, iframeQueryParams } = useContext(SettingsContext);
  const [ reservedClicked, setReservedClicked ] = useState(false);
  const history = useHistory();

  if (isShopify) {
    return null;
  }

  const onClick = async () => {
    if (listing.is_reserved) {
      return setReservedClicked(true);
    }

    history.push(`/request/px-order?${iframeQueryParams}`, { listing });
  }

  if (reservedClicked) {
    return <Alert tone="warning">This product is currently under reservation.</Alert>;
  }

  return (
    <Button variant="secondary" onClick={onClick} data-btn="px-new">
      Part exchange
    </Button>
  );
}

export default PartExchangeButton;
